import { SearchIcon as LibSearchIcon } from '@heroicons/react/outline';

import BaseIcon, { IconProps } from '@/components/icons/base-icon';

const SearchIcon = (props: IconProps) => (
  <BaseIcon Icon={LibSearchIcon} {...props} />
);

export default SearchIcon;
